export function onlyInteger($event) {
  let keyCode = $event.keyCode ? $event.keyCode : $event.which;
  // only allow int
  if (
    (keyCode < 48 || keyCode > 57) &&
    (keyCode === 44 || keyCode === 46 || keyCode === 101)
  ) {
    // 46 is dot, 44 is comma, 101 is 'e'
    $event.preventDefault();
  }
}
export function onlyDecimal($event, currentValue) {
  let keyCode = $event.keyCode ? $event.keyCode : $event.which;
  // only allow decimal
  if (
    (keyCode < 48 || keyCode > 57) &&
    (keyCode === 44 || keyCode === 101) 
  ) {
    // 46 is dot, 44 is comma, 101 is 'e'
    $event.preventDefault();
  } if (keyCode === 46 && currentValue.includes('.')) {
    $event.preventDefault();
  }
}